import axios from 'axios'
import { PageDataResponse,DataArrayResponse ,PageResponse} from '../models/PageResponse'
import {Location, DbLocation,DeleteData} from '../models'
import { config } from '../config'
import { CookieHelper } from '../helpers'

const apiUrl = config.API_URL

export default class ProjectService
{
    protected headers = {}
 protected token = ""

    constructor(token:string | null){
        if(token){
            this.token = token
            this.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        }
    }
    async getAll(page: number,limit: number,key:string){
        let options = {
                headers:this.headers,
                params: {
                    page: page,
                    limit: limit,
                    key: key
                }
            }
        
        const { data }  = await axios.get<PageDataResponse<DbLocation>>(`${apiUrl}/v1/locations/call`, options )
        
        return data;
    }

    async getLimit(){
        let options = {
            headers: this.headers
        }
        const { data }   = await axios.get<DataArrayResponse<Location>>(`${apiUrl}/v1/locations/limit`,options )
        return data;
    }

    async Search(key:string){
        let options = {
            headers:this.headers,
            params: {
                key: encodeURI(key)
            }
        }
        const { data }   = await axios.get<DataArrayResponse<Location>>(`${apiUrl}/v1/locations/search`,options )
        return data;
    }

    async create(location: DbLocation){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers:this.headers,
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/locations/call`,JSON.stringify(location),options )
        return data;
    }

    async update(location: DbLocation){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/locations/call`,JSON.stringify(location),options )
        return data;
    }

    async updateStatus(location: DbLocation){
        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/locations/status`,JSON.stringify(location),options )
        return data;
    }

    async delete(id: number,updateBy: string){
        if(!this.token) return null
        
        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers:this.headers
        }
        let deleteData:DeleteData = {
            id:id,
            updateBy:updateBy
        }
        const { data }  = await axios.post<PageResponse>(`${apiUrl}/v1/locations/delete`,JSON.stringify(deleteData),options )
        return data;
    }
}